module.exports = __webpack_public_path__ + "img/case6.7eccb5da.jpg";